export default __webpack_public_path__ + "static/media/image3.52cb6406.png";